<template>
<div>
  Voicemail Settings<br><br>
  <div class="container" style="top-border:1px">
    {{voicemail.mailbox}} {{voicemail.fullname}}<br><br>

    <div class="form-group" style="position:relative" >
      <label class="control-label" for="mailboxtxt">Mailbox</label>
      <input type="text" id="mailboxtxt" disabled class="form-control" v-model="voicemail.mailbox" />
    </div>

    <div class="form-group" style="position:relative" >
      <label class="control-label" for="passwordtxt">Password</label>
      <input type="text" id="passwordtxt" class="form-control" v-model="voicemail.password" />
    </div>

    <div class="form-group" style="position:relative" >
      <label class="control-label" for="skippasswordselect">Skip Password? (on assigned phones)</label>
      <select id="skippasswordselect" class="form-control" v-model="voicemail.skip_password_on_assigned_devices">
        <option value="Y">Yes</option>
        <option value="N">No</option>
      </select>
    </div>

    <div class="form-group" style="position:relative" >
      <label class="control-label" for="attachselect">Send email?</label>
      <select id="attachselect" class="form-control" v-model="voicemail.attach">
        <option value="yes">Yes</option>
        <option value="no">No</option>
      </select>
    </div>

    <div v-if="voicemail.attach=='yes'" class="form-group" style="position:relative" >
      <label class="control-label" for="emailtxt">Email address</label>
      <input type="text" id="emailtxt" class="form-control" v-model="voicemail.email" />
    </div>

    <div v-if="voicemail.attach=='yes'" class="form-group" style="position:relative" >
      <label class="control-label" for="deleteselect">Delete after email?</label>
      <select id="deleteselect" class="form-control" v-model="voicemail.delete">
        <option value="yes">Yes</option>
        <option value="no">No</option>
      </select>
    </div>

    <div class="form-group" style="position:relative" >
      <label class="control-label" for="deleteselect">Type new voicemail greeting?</label>
      <select id="deleteselect" class="form-control" v-model="typevoicemail">
        <option value="yes">Yes</option>
        <option value="no">No</option>
      </select>
    </div>

    <div v-if="typevoicemail=='yes'" class="form-group" style="position:relative" >
      <label class="control-label" for="emailmessage">Message</label>
      <textarea rows=4 type="text" id="emailmessage" class="form-control" v-model="voicemail.typed_voicemail" />
    </div>

    <div v-if="typevoicemail=='yes'" class="form-group" style="position:relative" >
      <label class="control-label" for="voiceselect">Choose Voice</label>
      <select id="voiceselect" class="form-control" v-model="voicemail.typed_voicemail_voice">
        <option value="en-US_AllisonVoice">Allison (en)</option>
        <option value="en-US_MichaelVoice">Michael (en)</option>
        <option value="fr-FR_ReneeVoice">Renee (fr)</option>
      </select>
    </div>

    <div class="form-group">
        <v-btn outlined @click="updateVoicemail(voicemail)" class='mr-2' color='green'>Update</v-btn>
        <v-btn outlined @click="cancelUpdate(voicemail)" color='red'>Cancel</v-btn>
    </div>

  </div>
</div>
</template>

<script >
export default {
  data: function() {
    return {
      typevoicemail: "no",
      selectedVoice: "en-US_AllisonVoice",
    }
  },
  props: {
      voicemail: Object,
      click2call: String,
  },
  methods: {
    getVoicemails: function() {
      this.$http.get(
        global.apiurl + "/voicemail-settings&" +
          "token=" + encodeURIComponent(this.click2call)
      ).then(response => {
        this.Mailboxes = response.body.Voicemails;
      });
    },
    updateVoicemail: function(mailbox) {
      //using get to update because Yii is a pain
      let self = this;
      let data = {
        ast_voicemail_id: mailbox.ast_voicemail_id,
        password: mailbox.password,
        skip_password_on_assigned_devices: mailbox.skip_password_on_assigned_devices,
        attach: mailbox.attach,
        email: mailbox.email,
        delete: mailbox.delete,
        typeNewGreeting: this.typevoicemail,
        typed_voicemail_voice: mailbox.typed_voicemail_voice,
        typed_voicemail: mailbox.typed_voicemail,
        token: self.click2call
      };
      this.$http.post(
        global.apiurl + "/voicemail-settings/updatevoicemail",
        data
      ).then(() => {
        this.$emit('closeVoicemail')
      });
    },
    objectToGet: function(obj) {
      var str = "";
      for (var key in obj) {
          if (str != "") {
              str += "&";
          }
          str += key + "=" + encodeURIComponent(obj[key]);
      }
      return str;
    },
    cancelUpdate: function() {
      this.$emit('closeVoicemail');
    }
  },
  mounted() {
    if (!this.voicemail.typed_voicemail_voice) {
      this.voicemail.typed_voicemail_voice = "en-US_AllisonVoice";
    }
  },
  components: {
    // 'app-voicemail-mailbox-settings': VoicemailMailboxSettings
  },
}
</script>
